import { render, staticRenderFns } from "./analytics_chart_doughnut.vue?vue&type=template&id=5961de2c"
import script from "./analytics_chart_doughnut.vue?vue&type=script&lang=ts"
export * from "./analytics_chart_doughnut.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports